var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMemberPerksIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 31.667,
    viewBox: "0 0 38 31.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3018",
    "data-name": "Rectangle 3018",
    width: 38,
    height: 31.667,
    transform: "translate(338 88.98)",
    fill: "#37d16f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_38",
    "data-name": "Mask Group 38",
    transform: "translate(-338 -88.98)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tickets_18882849",
    d: "M147.5,284.525a4.275,4.275,0,0,1,4.275-4.275h29.45a4.275,4.275,0,0,1,4.275,4.275v5.225a.475.475,0,0,1-.475.475,4.75,4.75,0,0,0,0,9.5.475.475,0,0,1,.475.475v5.225a4.275,4.275,0,0,1-4.275,4.275h-29.45a4.275,4.275,0,0,1-4.275-4.275V300.2a.475.475,0,0,1,.475-.475,4.75,4.75,0,0,0,0-9.5.475.475,0,0,1-.475-.475Zm17.245,4.928a1.929,1.929,0,0,1,3.509,0l.771,1.612a1.015,1.015,0,0,0,.758.577l1.688.253a2.048,2.048,0,0,1,1.084,3.462l-1.194,1.2a1.124,1.124,0,0,0-.3.973l.286,1.718a1.974,1.974,0,0,1-2.839,2.14l-1.55-.841a.949.949,0,0,0-.912,0l-1.55.841a1.974,1.974,0,0,1-2.839-2.14l.286-1.718a1.123,1.123,0,0,0-.3-.973l-1.194-1.2a2.048,2.048,0,0,1,1.084-3.462l1.688-.253a1.015,1.015,0,0,0,.758-.577Z",
    transform: "translate(190.5 -190.161)",
    fill: "#37d16f",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberPerksIcon);
export default __webpack_public_path__ + "static/media/memberPerks_icon.66f59aff066f1ad054734ba98535a116.svg";
export { ForwardRef as ReactComponent };